/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PagePersonInfo.vue?vue&type=template&id=78b4ae78"
import script from "./PagePersonInfo.vue?vue&type=script&lang=js"
export * from "./PagePersonInfo.vue?vue&type=script&lang=js"
import style0 from "./PagePersonInfo.vue?vue&type=style&index=0&id=78b4ae78&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports